import { render, staticRenderFns } from "./medicament.vue?vue&type=template&id=3b7b1e1d"
import script from "./medicament.vue?vue&type=script&lang=js"
export * from "./medicament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports